/**
 * Created by boris on 3/31/17.
 */
import {
  SET_FOLLOWERS_LIST,
  INITIAL_FOLLOWERS_LIST,
  SET_NEXT_FOLLOWERS_LIST,
  SET_FOLLOWER_LIST_USER,
  SET_DELETE_FOLLOWER,
  SET_SEARCH_FOLLOWERS_LOADING,
} from '../actions/constants'

const initialState = {
  isLoading:  true,
  users:      new Map(),
  pagination: {},
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_SEARCH_FOLLOWERS_LOADING: {
      return {
        isLoading:  true,
        users:      new Map(),
        pagination: {},
      }
    }

    case INITIAL_FOLLOWERS_LIST: {
      return {
        isLoading:  true,
        users:      new Map(),
        pagination: {},
      }
    }

    case SET_FOLLOWERS_LIST: {
      let newState = {
        isLoading:  false,
        users:      new Map(),
        pagination: {},
      }
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }

      return newState
    }

    case SET_DELETE_FOLLOWER: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      newState.users.delete(action.user_id)
      return newState
    }

    case SET_NEXT_FOLLOWERS_LIST: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.data) {
        const { data, pagination } = action.data
        data.forEach(user => newState.users.set(user.id, user))
        newState.pagination = Object.assign({}, pagination)
      }

      return newState
    }

    case SET_FOLLOWER_LIST_USER: {
      let newState = Object.assign({}, state, {
        users:      new Map(state.users),
        pagination: Object.assign({}, state.pagination),
      })
      if (action.user) {
        const { user } = action
        newState.users.set(user.id, user)
      }

      return newState
    }

    default:
      return state
  }
}
